import { Fragment, useState } from "react";
import { Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import ContactCard from "../../../../../components/Cards/ContactCard";
import DefaultPlaceholder from "../../../../../components/Placeholders/Default";
import AddContactDrawer from "../Drawers/AddContact";
import { toast } from "react-toastify";
import { del } from "../../../../../utils/helpers/api";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";

function ContactsTab({ isNew, customerData, localContacts, onLocalAdd, onLocalEdit, onLocalDelete, onSaved }) {
  const { t } = useTranslation();
  const [addContactOpen, setAddContactOpen] = useState(false);
  const [editContactData, setEditContactData] = useState(null);
  const [contactToDelete, setContactToDelete] = useState(null);

  const contacts = isNew ? localContacts : (customerData?.contacts || []);

  const deleteContact = async () => {
    if (isNew) {
      onLocalDelete?.(contactToDelete);
      setContactToDelete(null);
      return;
    }
    const data = await del('/crm/customers/contacts/delete/' + contactToDelete);
    if (data.success) {
      toast.success(data.message || t('contact.deleteContact'));
      onSaved();
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setContactToDelete(null);
  }

  const handleLocalSave = (data) => {
    if (data._tempId && editContactData?._tempId) {
      onLocalEdit?.(data._tempId, data);
    } else {
      onLocalAdd?.(data);
    }
  };

  return(
    <Fragment>
      <Row className="g-3">
        {contacts.length > 0 &&
          contacts.map((data, key) => (
            <Col md="6" key={isNew ? data._tempId : key}>
              <ContactCard
                data={data}
                onEditClick={() => {
                  setEditContactData(data);
                  setAddContactOpen(true);
                }}
                onDeleteClick={() => setContactToDelete(isNew ? data._tempId : data.id)}
              />
            </Col>
          ))
        }

        <Col md="6">
          <DefaultPlaceholder
            onClick={() => {
              setAddContactOpen(true);
              setEditContactData(null);
            }}
          >
            + {t('crm.contactInformation')}
          </DefaultPlaceholder>
        </Col>
      </Row>

      <AddContactDrawer
        isOpen={addContactOpen}
        toggle={() => setAddContactOpen(!addContactOpen)}
        isNew={isNew}
        customerData={customerData}
        editData={editContactData}
        onSaved={onSaved}
        onLocalSave={handleLocalSave}
      />

      <ConfirmationModal
        isOpen={!!contactToDelete}
        toggle={() => setContactToDelete(null)}
        title={t('contact.deleteContact')}
        message={t('contact.deleteContactConfirm')}
        onConfirm={deleteContact}
      />
    </Fragment>
  );
}

export default ContactsTab;
